import {ChangeDetectionStrategy, Component, Input, computed, signal} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {MatTooltip} from '@angular/material/tooltip';
import {
  ProfilerLanguage,
  profilerLanguageLabelKey,
  toProfilerLanguage,
} from '../../constants/profiler-language';

/**
 * Zeigt die Oberflaechensprache des Profilers als Flagge — reine Anzeige, kein Button.
 * SVG statt Emoji, weil Windows 🇩🇪/🇬🇧 haeufig nur als Buchstabenpaar rendert.
 *
 * Die Flagge traegt selbst keinen Vorlesetext: sie steht entweder in einem Element mit
 * eigener Rolle — dessen Kinder fuer die Accessibility-API praesentational sind — oder
 * neben dem Sprachnamen als Text. Vorgelesen wird sie ueber das umgebende Element.
 */
@Component({
  selector: 'app-profiler-language-flag',
  templateUrl: './profiler-language-flag.component.html',
  styleUrl: './profiler-language-flag.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip, TranslatePipe],
})
export class ProfilerLanguageFlagComponent {
  private static nextId = 0;

  private readonly _langKey = signal<string | null | undefined>(null);

  /** Eindeutig je Instanz: der Union Jack braucht einen eigenen `clipPath`. */
  protected readonly clipId = `profiler-flag-clip-${ProfilerLanguageFlagComponent.nextId++}`;

  @Input()
  set langKey(value: string | null | undefined) {
    this._langKey.set(value);
  }

  /** Aus, wo der Sprachname ohnehin als Text danebensteht. */
  @Input() showTooltip = true;

  protected readonly language = computed<ProfilerLanguage | null>(() =>
    toProfilerLanguage(this._langKey()),
  );

  protected readonly labelKey = computed<string>(() =>
    profilerLanguageLabelKey(this.language()),
  );
}
